import { defineMessage } from 'magpie-lib/models';
import * as t from 'ts-schema';
export const assistantPublishMessage = defineMessage({
  type: '@assistant/publish',
  payloadSchema: t.object({
    isAssistantBusy: t.boolean
  })
});